import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  input: {
    marginVertical: 8
  }
});

export default styles;
